import api from './client.js'

/* OBS-instances via obs-websocket. Backend praat, frontend stuurt commands.
   Password blijft server-side; API returned password als '***' bij list/get. */
export const obsAPI = {
  list:        ()                => api.get('/obs/instances'),
  get:         (id)              => api.get(`/obs/instances/${id}`),
  create:      (body)            => api.post('/obs/instances', body),
  update:      (id, body)        => api.patch(`/obs/instances/${id}`, body),
  remove:      (id)              => api.delete(`/obs/instances/${id}`),
  test:        (body)            => api.post('/obs/instances/test', body),
  reconnect:   (id)              => api.post(`/obs/instances/${id}/reconnect`),
  scenes:      (id)              => api.get(`/obs/instances/${id}/scenes`),
  setScene:    (id, sceneName)   => api.post(`/obs/instances/${id}/scene`, { sceneName }),
}
